import * as React from 'react';
import { ToxnotReactModal, ToxnotReactModalBody, ToxnotReactModalFooter } from '../ToxnotReactModal';
import { IStringLocalizer } from '../../../utilities/IStringLocalizer';
import { useLocalizer } from './hooks/useLocalizer';

interface AITerminateModalProps {
    isOpen: boolean;
    isSubmitting?: boolean;
    onConfirm: () => void;
    onCancel: () => void;
    localizer?: IStringLocalizer;
}

export const AITerminateModal: React.FC<AITerminateModalProps> = ({
    isOpen,
    isSubmitting = false,
    onConfirm,
    onCancel,
    localizer
}) => {
    const localize = useLocalizer(localizer);

    if (!isOpen) {
        return null;
    }

    return (
        <ToxnotReactModal
            modalId="ai-terminate-modal"
            localizedTitle={localize('Warning')}
            additionalClasses="ai-terminate-modal-left-align"
            onClose={onCancel}
        >
            <ToxnotReactModalBody>
                <div className="ai-terminate-modal-content">
                    <p className="ai-terminate-modal-message">
                        {localize('Are you sure you want to terminate this AI processing request? This request will be terminated immediately. You can try again with the same files, upload different files, or proceed without using AI.')}
                    </p>
                </div>
            </ToxnotReactModalBody>
            <ToxnotReactModalFooter enabledCloseButton={false} localizer={localizer!}>
                <button
                    type="button"
                    className="btn btn-toxnot-primary ai-terminate-modal-cancel-button"
                    data-dismiss="modal"
                    onClick={onCancel}
                    disabled={isSubmitting}
                >
                    {localize('Cancel')}
                </button>
                <button
                    type="button"
                    className="btn btn-toxnot-danger ai-terminate-modal-confirm-button"
                    data-dismiss="modal"
                    onClick={onConfirm}
                    disabled={isSubmitting}
                >
                    {localize('Terminate Request')}
                </button>
            </ToxnotReactModalFooter>
        </ToxnotReactModal>
    );
};

export default AITerminateModal;
